module.exports = __webpack_public_path__ + "media/photographerOnboarding/google-9d42f19b.png";